export default __webpack_public_path__ + "static/media/ezg_logo.70ad802b.png";